<template>
	<div>
		<myheader :headTitle="headertitle"></myheader>
		<div class="header_extend_main" style="padding-bottom: .5rem;">
			<div class="header_extend_back"></div>
			<div class="header_extend_content">
				<div class="all_tips_content_card">
					<div class="text14 textcolor333 all_text_center">{{title}}</div>
					<div class="text14 textcolor333 margin_top_10" style="white-space: pre-wrap">{{content}}</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Vue from "vue";
	export default {
		data() {
			return {
				headertitle: '详情',
				//消息
				data: '',
				//消息标题
				title: '',
				//消息内容
				content: '',
				//true消息  false公告
				type: '1', 
			};
		},
		mounted() {
			this.getDetails();
		},
		methods: {
			// 获取消息/公告详情
			getDetails() {
				this.type = this.$route.query.type;
				let url = "";
				if(this.type === '1'){
					url = "/message/api/" + this.$route.query.id;
				} else {
					this.headertitle = '公告'
					url = "/message/api/notification/" + this.$route.query.id;
				}
				//console.log(url)
				this.$post(url)
					.then((res) => {
						if (res.success && res.data) {
							this.data = res.data
							if (this.type === '1') {
								this.headertitle = this.data.messageType + '详情';
								this.title = this.data.messageCaption.replace('！', '');
								this.content = this.data.messageContent.replaceAll('，', '，\r\n')
							} else {
								this.title = this.data.notificationTitle;
								this.content = this.data.notificationText.replaceAll('\n\n', '\r\n')
							}
						} else {
							this.$Toast(res.message || '网络异常！');
						}
					})
					.catch((res) => {
						this.$Toast({
							duration: 1500, // 持续展示 toast
							forbidClick: true,
							message: res.message,
						});
					});
			},
		},
	};
</script>

<style scoped lang="scss">
	@import "../../styles/global.css";
	
</style>